import translate from '../localization/translate';

const translator = {
  methods: {
    tr: (lbl, params = []) => translate(lbl, params),
  },
};
export default translator;
